import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        productId: String
    }

    toggle(event) {
        event.preventDefault()

        if (!this.hasProductIdValue) {
            console.error('Missing product ID or type')
            return
        }

        const url = `/wish/new?id=${this.productIdValue}`
        const heartIcon = event.currentTarget.querySelector('.bi')

        fetch(url, {
            headers: {
                Accept: 'text/vnd.turbo-stream.html'
            }
        })
            .then(response => response.text())
            .then(html => {
                Turbo.renderStreamMessage(html)
                
                // Update all wishlist buttons for this product
                const productId = this.productIdValue
                const allWishlistButtons = document.querySelectorAll(`[data-product-id="${productId}"]`)
                
                allWishlistButtons.forEach(button => {
                    const icon = button.querySelector('.bi')
                    const isCurrentlyWishlisted = icon.classList.contains('bi-heart')
                    
                    if (icon) {
                        if (isCurrentlyWishlisted) {
                            // Add to wishlist
                            icon.classList.remove('bi-heart', 'text-info')
                            icon.classList.add('bi-heart-fill', 'text-danger')
                            
                            // Update button style if it has btn-primary/btn-info classes
                            if (button.classList.contains('btn-primary')) {
                                button.classList.remove('btn-primary')
                                button.classList.add('btn-info')
                            }
                        } else {
                            // Remove from wishlist
                            icon.classList.remove('bi-heart-fill', 'text-danger')
                            icon.classList.add('bi-heart', 'text-info')
                            
                            // Update button style if it has btn-info class
                            if (button.classList.contains('btn-info') && !button.classList.contains('wish')) {
                                button.classList.remove('btn-info')
                                button.classList.add('btn-primary')
                            }
                        }
                    }
                })
            })
            .catch(error => {
                console.error('Error:', error)
            })
    }
}
